export default {
  sm: `@media (min-width: 360px)`,
  md: `@media (min-width: 720px)`,
  lg: `@media (min-width: 1200px)`,
};
